import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { SiteLayout } from "@/components/site/SiteLayout";
import { ContactInstructor } from "@/components/site/ContactInstructor";

export default function Legal() {
  const { slug } = useParams();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["legal", slug],
    queryFn: async () => (await api.get(`/legal/${slug}`)).data,
  });
  useEffect(() => { document.title = data?.title ? `${data.title} — Epic Fade Academy` : "Epic Fade Academy"; }, [data]);

  return (
    <SiteLayout>
      <div className="mx-auto max-w-3xl px-6 py-16">
        {isLoading ? (
          <Loader2 className="mx-auto h-8 w-8 animate-spin text-[#DCA846]" />
        ) : isError ? (
          <p className="text-zinc-400">Page not found.</p>
        ) : (
          <>
            <h1 className="font-display text-4xl font-bold uppercase tracking-tighter">{data.title}</h1>
            <div className="prose prose-invert mt-8 max-w-none text-zinc-300"
              dangerouslySetInnerHTML={{ __html: data.content }} />
            {slug === "contact" && (
              <div className="mt-10">
                <ContactInstructor context="General enquiry" />
              </div>
            )}
          </>
        )}
      </div>
    </SiteLayout>
  );
}
